import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-progress-indicator',
  imports: [],
  templateUrl: './progress-indicator.component.html',
  styleUrl: './progress-indicator.component.css'
})
export class ProgressIndicatorComponent {
  @Input()
  currentStep: number = 1;
}
